import { render } from "./WDataTableHeader.vue?vue&type=template&id=e4a45652&ts=true"
import script from "./WDataTableHeader.vue?vue&type=script&lang=ts"
export * from "./WDataTableHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__